"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartOptions = void 0;
class ExponentialBackoffRecurringTaskRunner {
    constructor(task, minIntervalMs, maxIntervalMs, intervalMultiplier) {
        this.timeoutId = null;
        this.cancel = null;
        this.stopped = false;
        this.start = (options) => {
            return this.run(options);
        };
        this.restart = (options) => {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            return this.run(options);
        };
        this.stop = () => {
            this.stopped = true;
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
        };
        this.run = (options) => __awaiter(this, void 0, void 0, function* () {
            if (this.stopped) {
                return;
            }
            let nextIntervalMs = this.minIntervalMs;
            const runInLoop = () => {
                if (this.stopped)
                    return;
                this.timeoutId = setTimeout((_) => __awaiter(this, void 0, void 0, function* () {
                    let reset = false;
                    try {
                        reset = yield this.task();
                    }
                    finally {
                        if (reset) {
                            nextIntervalMs = this.minIntervalMs;
                        }
                        else {
                            nextIntervalMs = Math.min(nextIntervalMs * this.intervalMultiplier, this.maxIntervalMs);
                        }
                    }
                    runInLoop();
                }), nextIntervalMs);
            };
            switch (options) {
                case StartOptions.TriggerTaskAndReturn:
                    this.task().finally(runInLoop);
                    break;
                case StartOptions.WaitBeforeFirstRun:
                    runInLoop();
                    break;
                case StartOptions.AwaitFirstRun: {
                    try {
                        yield this.task();
                    }
                    finally {
                        runInLoop();
                    }
                    break;
                }
            }
        });
        this.task = task;
        this.minIntervalMs = minIntervalMs;
        this.maxIntervalMs = maxIntervalMs;
        this.intervalMultiplier = intervalMultiplier;
    }
    // When the task returns true the interval will be reset to the minimum
    static startNew(task, minIntervalMs, maxIntervalMs, intervalMultiplier, options) {
        if (intervalMultiplier <= 1) {
            throw new Error("'intervalMultiplier' must be > 1");
        }
        const taskRunner = new ExponentialBackoffRecurringTaskRunner(task, minIntervalMs, maxIntervalMs, intervalMultiplier);
        taskRunner.start(options);
        return taskRunner;
    }
}
exports.default = ExponentialBackoffRecurringTaskRunner;
var StartOptions;
(function (StartOptions) {
    StartOptions[StartOptions["TriggerTaskAndReturn"] = 0] = "TriggerTaskAndReturn";
    StartOptions[StartOptions["WaitBeforeFirstRun"] = 1] = "WaitBeforeFirstRun";
    StartOptions[StartOptions["AwaitFirstRun"] = 2] = "AwaitFirstRun";
})(StartOptions = exports.StartOptions || (exports.StartOptions = {}));
